export const extraLargeDesktopViewBreakpoint = "xl";
export const largeDesktopViewBreakpoint = "lg";
export const mobileViewBreakpoint = "md";
export const smallMobileViewBreakpoint = "sm";
export const extraSmallMobileBreakpoint = "xs";
